import { Tokens } from '@/assets/tokens'
import { css, styled } from 'styled-components'

export const ComponentContainer = styled.label<{
  $hasLabel?: boolean
  $align?: 'flex-start' | 'flex-end'
  $direction?: 'row' | 'column'
  $disabled?: boolean
}>`
  width: fit-content;
  height: ${(props) =>
    props.$direction === 'row' ? '1.75rem'
    : props.$hasLabel ? Tokens.HeightInput
    : '1.75rem'};

  display: flex;
  flex-direction: ${(props) => props.$direction || 'column'};
  justify-content: flex-start;
  align-items: ${(props) => (props.$direction === 'row' ? 'center' : props.$align || 'flex-start')};

  gap: ${(props) => (props.$direction === 'row' ? '12px' : '4px')};

  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.$disabled ? '0.5' : '1')};
`

export const Label = styled.span`
  color: ${Tokens.ColorTextPrimary};
`

export const Component = styled.div<{ checked: boolean; $disabled?: boolean }>`
  position: relative;

  flex: 1;

  width: 3.5rem;
  height: 1.75rem;
  border-radius: 20px;

  background-color: ${Tokens.ColorBorder};
  transition: all ease-in-out 0.25s;

  & > input {
    display: none;
  }

  &:after {
    position: absolute;
    content: '';
    width: 1.2rem;
    height: 1.2rem;
    border-radius: 20px;
    top: 0.275rem;
    left: 0.25rem;
    background-color: ${Tokens.ColorWhite};
    transition: all ease-in-out 0.25s;
  }

  ${({ checked }) =>
    checked &&
    css`
      background-color: ${Tokens.ColorUIPrimary};

      &:after {
        transform: translateX(calc(100% + 0.55rem));
      }
    `}
`

export const Input = styled.input`
  width: 100%;
  height: 100%;
  display: none;
`
